import { LoaderFunction, redirect } from "react-router-dom";
import { RootState } from "../../store/store";
import { store } from "../../store/store";
import { ROUTES } from "../../utils/constants";
import { verifyUserTokens } from "../../models/authSlice";

export const loginLoader: LoaderFunction = async () => {
  await store.dispatch(verifyUserTokens());
  const state: RootState = store.getState();

  if (state.auth.isAuthenticated) {
    return redirect(ROUTES.HOME_SCREEN);
  }
  return null;
};
